import { useEffect, useRef } from "react";

const useClickOutside = (ref, isOpen, onClose) => {
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleClickOutside = (event) => {
      if (!ref.current?.contains(event.target)) {
        onCloseRef.current();
      }
    };

    const timer = window.setTimeout(() => {
      document.addEventListener("pointerdown", handleClickOutside, true);
    }, 0);

    return () => {
      window.clearTimeout(timer);
      document.removeEventListener("pointerdown", handleClickOutside, true);
    };
  }, [isOpen, ref]);
};

export default useClickOutside;
